module.exports = __webpack_public_path__ + "static/media/accuracy.78b72d0f.svg";